import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../utils';
import { ReducerPaths } from '../../constants/reducerPaths';
import { getAllSmartInterviews } from './queries/get-all-smart-interviews.query';
import { updateSmartInterview } from './mutation/update-smart-interview.mutation';
import { createSmartInterview } from './mutation/create-smart-interview.mutation';
import { deleteSmartInterview } from './mutation/delete-smart-interview.mutation';
import { getOneSmartInterview } from './queries/get-one-smart-interview.query';
import { getCandidateSmartInterviewsVideos } from './queries/get-candidate-smart-interviews-videos.query';
import { updateVisibilitySmartInterview } from './mutation/update-smart-interview-visibility.mutation';
import { deleteCandidateSmartInterview } from './mutation/delete-candidate-smart-interview.mutation';

export const smartInterviewsApi = createApi({
  reducerPath: ReducerPaths.SMART_INTERVIEWS,
  baseQuery,
  endpoints: (builder) => ({
    getOneSmartInterview: getOneSmartInterview(builder),
    getAllSmartInterviews: getAllSmartInterviews(builder),
    updateSmartInterview: updateSmartInterview(builder),
    createSmartInterview: createSmartInterview(builder),
    deleteSmartInterview: deleteSmartInterview(builder),
    getCandidateSmartInterviewsVideos:
      getCandidateSmartInterviewsVideos(builder),
    updateVisibilitySmartInterview: updateVisibilitySmartInterview(builder),
    deleteCandidateSmartInterview: deleteCandidateSmartInterview(builder),
  }),
  tagTypes: ['SmartInterviews', 'SmartInterviewsVideos'],
});

export const {
  useGetAllSmartInterviewsQuery,
  useUpdateSmartInterviewMutation,
  useCreateSmartInterviewMutation,
  useDeleteSmartInterviewMutation,
  useLazyGetOneSmartInterviewQuery,
  useGetCandidateSmartInterviewsVideosQuery,
  useUpdateVisibilitySmartInterviewMutation,
  useDeleteCandidateSmartInterviewMutation,
} = smartInterviewsApi;
